module.exports = __webpack_public_path__ + "img/sars_cov_ies_en.771e08cf.jpg";